import React from 'react'
import { connect } from 'react-redux'

import {load_shop, load_girls_schedule} from '../actions'
import {escapeHtml} from '../utils.js'

import Header from './header.react.js'
import Footer from './footer.react.js'

import ShopInfo from './shopinfo.react.js'

const mapStateToProps = (state) => {
  return {
    shops: state.shops,
  }
}

const mapDispatchToProps = {
  load_shop, load_girls_schedule
}

const ShopPage = React.createClass({
  componentDidMount() {
    this.props.load_shop(this.props.location.query.shopid)
      .then((ret) => {
        this.props.load_girls_schedule(this.props.shops[0]);

        var shopname = escapeHtml(this.props.shops[0].name)
        $('meta[name=description]').remove();
        $('head').append(`<meta name="description" content="${shopname} の出勤情報をひと目で確認！ 一番見やすい池袋風俗情報サイト。">`);
        document.title = `${shopname} の出勤情報をひと目で確認！ 【池袋紳士】`


      })
  },
  componentWillUpdate: function() {
  },

  render() {
    if (!this.props.shops.length) {
      return null;
    }
    const shop = this.props.shops[0];
    return (
      <div>
        <Header />

        <div className='container-fluid'>
          <div className='row'>
            <div className='col-sm-12'>
              <ShopInfo shop={shop} girllist='schedule'></ShopInfo>
            </div>
          </div>
        </div>


        <Footer />
      </div>
    )
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ShopPage)



// WEBPACK FOOTER //
// ./components/shoppage.react.js